import { CustomQuickLink } from './models';

export const QuickLinksUserSettingsKey = 'QUICK_LINKS';

export interface QuickLinksUserSettings {
  hiddenLinks: string[];
  customLinks: CustomQuickLink[];
  linksOrder: string[];
}

const defaultQuickLinksUserSettings: QuickLinksUserSettings = {
  hiddenLinks: [],
  customLinks: [],
  linksOrder: [],
};

export const resolveQuickLinksUserSettings = (
  remoteUserSettings?: Partial<QuickLinksUserSettings>,
): QuickLinksUserSettings => {
  if (!remoteUserSettings) {
    return defaultQuickLinksUserSettings;
  }

  return { ...defaultQuickLinksUserSettings, ...remoteUserSettings };
};
